import React, { memo, useCallback, useMemo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import classes from './BaseDatePicker.module.scss'
import NativeSelect from 'components/ui/controls/NativeSelect'
import moment from 'moment'

const months = moment
	.monthsShort()
	.map(month => ({ value: month, label: month }))

const minUserAge = 18

const years = Array.from({ length: 150 }, (value, index) => {
	const year = moment().format('yyyy') - minUserAge - index
	return { value: year, label: year }
})

const format = 'YYYY-MM-DD'

const BaseDatePicker = ({ className, value, onChange }) => {
	const { day, month, year } = useMemo(
		() => ({
			day: value ? moment(value).format('D') : '',
			month: value ? moment(value).format('MMM') : '',
			year: value ? moment(value).format('yyyy') : ''
		}),
		[value]
	)

	const days = useMemo(
		() =>
			Array.from({ length: +moment(value).daysInMonth() }, (value, index) => ({
				value: (index + 1).toString(),
				label: (index + 1).toString()
			})),
		[value]
	)

	const handleChange = useCallback(
		({ target: { value: newValue, name } }) => {
			if (name === 'day') {
				if (+newValue > +day) {
					onChange(
						moment(value)
							.add(Math.abs(newValue - day), 'days')
							.format(format)
					)
				} else {
					onChange(
						moment(value)
							.subtract(Math.abs(newValue - day), 'days')
							.format(format)
					)
				}
			} else {
				onChange(moment(value).set(name, newValue).format(format))
			}
		},
		[day, onChange, value]
	)

	return (
		<div className={clsx(classes.root, className, 'flex-center')}>
			<NativeSelect
				className="grow mr-1"
				placeholder="dd"
				options={days}
				value={day}
				name="day"
				onChange={handleChange}
			/>
			<NativeSelect
				className="grow mr-1"
				placeholder="mm"
				options={months}
				value={month}
				name="month"
				onChange={handleChange}
			/>
			<NativeSelect
				className="grow-2"
				placeholder="yyyy"
				options={years}
				value={year}
				name="year"
				onChange={handleChange}
			/>
		</div>
	)
}

BaseDatePicker.propTypes = {
	value: PropTypes.string.isRequired
}

BaseDatePicker.defaultProps = {
	value: ''
}

export default memo(BaseDatePicker)
